import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  customConvertIntoSelect2OptionsClasses,
  getFetchOptions,
  uploadImage,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";

const EditTeacher = () => {
  const [provsOption, setProvsOption] = useState([]);
  const [cityOption, setCityOption] = useState([]);
  const [schoolOption, setSchoolOption] = useState([]);
  const [subjectOption, setSubjectOption] = useState([]);
  const [relationTeachersData, setRelationTeachersData] = useState([]);
  const [relationTeacherClasses, setRelationTeacherClasses] = useState([]);
  // const [subjects, setSubjects] = useState([]);
  const [teacherData, setTeacherData] = useState({});
  const [oldTeacherData, setOldTeacherData] = useState({});
  const [avatar, setAvatar] = useState(null);

  const currentMonth = new Date().getMonth();
  const schoolYear =
    currentMonth >= 8
      ? `${new Date().getFullYear()}${new Date().getFullYear() + 1}`
      : `${new Date().getFullYear() - 1}${new Date().getFullYear()}`;

  const breadcrumb = {
    current_section: "Modifica",
    sections: [
      { name: "Scuole", route_name: null, params: [] },
      { name: "Gestione insegnante", route_name: null, params: [] },
      { name: "Modifica", route_name: null, params: [] },
    ],
  };

  useEffect(() => {
    const fetchProvs = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/provincie`,
          fetchOptions
        );
        const result = await response.json();

        result.provincie.sort((a, b) => a.nome.localeCompare(b.nome));

        setProvsOption(
          convertIntoSelect2Options(result.provincie, "id", "nome")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/scuola`,
          fetchOptions
        );
        const result = await response.json();
        setSchoolOption(
          convertIntoSelect2Options(result.return.scuola, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchTeachers = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/user?id=${window.location.pathname
            .split("/")
            .pop()}`,
          fetchOptions
        );
        const result = await response.json();
        setTeacherData(result.return.user);
        setOldTeacherData(result.return.user);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchSubjects = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/materie`,
          fetchOptions
        );
        const result = await response.json();

        setSubjectOption(
          convertIntoSelect2Options(result.return.materie, "id", "materia")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchProvs();
    fetchSchools();
    fetchSubjects();
    fetchTeachers();
  }, []);

  useEffect(() => {
    handleImportProvinceChange(teacherData.idprovincia);
    handleSchoolFilter(teacherData.idprovincia, teacherData.idcomune);
  }, [teacherData.idprovincia]);

  useEffect(() => {
    handleSchoolFilter(teacherData.idprovincia, teacherData.idcomune);
  }, [teacherData.idcomune]);

  useEffect(() => {
    if (!teacherData.idscuola || teacherData.idscuola === undefined) return;

    const fetchAllClassesOfSchool = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllClasses?schoolId=${teacherData.idscuola}&schoolYear=${schoolYear}`,
          fetchOptions
        );
        const result = await response.json();

        if (result.error) {
          setRelationTeacherClasses([]);
          return;
        }

        setRelationTeacherClasses(
          customConvertIntoSelect2OptionsClasses(
            result,
            "idclassi",
            "classe",
            "sezione"
          )
        );
      } catch (error) {
        console.error(error);
      }
    };

    const fetchTeacherClasses = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${
            axios.defaults.baseBFFUrl
          }/fe/getTeacherClasses?userId=${window.location.pathname
            .split("/")
            .pop()}&schoolId=${teacherData.idscuola}&schoolYear=${schoolYear}`,
          fetchOptions
        );
        const result = await response.json();
        if (result.error) {
          setRelationTeachersData([]);
          return;
        }

        let allRelations = [];
        if (result.length === 0) {
          setRelationTeachersData([]);
          return;
        }

        result.forEach((relation) => {
          let obj = {};
          obj.id = relation.id;
          obj.classId = relation.idclasse;
          obj.subjectId = relation.idmateria;

          allRelations.push(obj);
        });

        setRelationTeachersData(allRelations);
      } catch (error) {
        console.error(error);
      }
    };

    fetchAllClassesOfSchool();
    fetchTeacherClasses();
  }, [teacherData.idscuola]);

  // Funzione per validare il codice fiscale italiano
  const isValidCF = (cf) => {
    if (!cf) return false;
    const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
    return regex.test(cf);
  };
  // Stato per gestire l'errore del codice fiscale
  const [cfError, setCfError] = useState("");
  const isValidEmail = (email) => {
    if (!email) return false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [emailError, setEmailError] = useState("");
  // Modifica handleSave per controllare il codice fiscale
  const handleSaveWithCFCheck = async () => {
    let hasError = false;

    if (!isValidCF(teacherData.cf)) {
      setCfError("Codice fiscale non valido");
      hasError = true;
    } else {
      setCfError("");
    }

    if (!isValidEmail(teacherData.email)) {
      setEmailError("Email non valida");
      hasError = true;
    } else {
      setEmailError("");
    }

    if (hasError) return;

    await handleSave();
  };

  const handleSchoolFilter = async (provinceId, cityId) => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllSchools?provinceId=${
            provinceId ?? ""
          }&townId=${cityId ?? ""}`,
          fetchOptions
        );

        const result = await response.json();

        if (result.error) {
          setSchoolOption([]);
          return;
        }

        setSchoolOption(
          convertIntoSelect2Options(result, "id", "denomistituto")
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchSchools();
  };

  const handleProvinceChange = async (event) => {
    if (!event) {
      setCityOption([]);
      setTeacherData({ ...teacherData, idprovincia: null });
      return;
    }
    setCityOption([]);
    setTeacherData({ ...teacherData, idprovincia: event?.value });

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${event?.value}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOption(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };

    fetchCities();
  };

  const handleImportProvinceChange = (id) => {
    if (!id) {
      setCityOption([]);
      setTeacherData({ ...teacherData, idprovincia: null });
      return;
    }
    setCityOption([]);
    setTeacherData({ ...teacherData, idprovincia: id });

    const fetchCities = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/app/getTowns?idprov=${id}`,
          fetchOptions
        );
        const result = await response.json();

        setCityOption(convertIntoSelect2Options(result, "id", "nome"));
      } catch (error) {
        console.error(error);
      }
    };
    fetchCities();
  };

  const handleCityChange = (event) => {
    setTeacherData({ ...teacherData, idcomune: event?.value });
  };

  const handleSchoolChange = (event) => {
    setTeacherData({ ...teacherData, idscuola: event?.value });
  };

  const handleAvatarChange = () => {
    if (!avatar) {
      alert("Nessuna immagine selezionata");
      console.error("No file selected");
      return;
    }

    const file = avatar;

    if (file) {
      uploadImage(file)
        .then(async (url) => {
          const fetchOptions = getFetchOptions(
            "application/json",
            { userId: teacherData.id, avatarUrl: url },
            "PUT"
          );
          const response = await fetch(
            `${axios.defaults.baseBFFUrl}/fe/updateTeacherAvatar`,
            fetchOptions
          );
          const result = await response.json();
          if (result.error) {
            alert(
              "Errore durante il caricamento dell'immagine del profilo. Riprova."
            );
            return;
          }

          alert("Immagine del profilo aggiornata con successo!");
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error uploading image:", error);
        });
    }
  };

  const handleRelationChange = (index, field, value) => {
    const updatedRelations = [...relationTeachersData];
    updatedRelations[index][field] = value;

    // Se sto modificando la classe, aggiungo anche classe e sezione
    if (field === "classId" && value) {
      const selectedClass = relationTeacherClasses.find(
        (c) => c.value === value
      );
      if (selectedClass) {
        updatedRelations[index].className = selectedClass.label.split(" ")[0];
        updatedRelations[index].section = selectedClass.label.split(" ")[1];
      }
    }

    setRelationTeachersData(updatedRelations);
  };

  const handleDeleteRelation = async (id) => {
    const relation = relationTeachersData.find((rel) => rel.id === id);
    if (relation && relation.new) {
      setRelationTeachersData((prev) => prev.filter((rel) => rel.id !== id));
      return;
    }

    const response = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/deleteTeacherClass?relationId=${id}`,
      getFetchOptions("application/json", {}, "DELETE")
    );

    const result = await response.json();

    if (!result.error) {
      setRelationTeachersData((prev) =>
        prev.filter((relation) => relation.id !== id)
      );
      alert("Relazione eliminata con successo!");
    } else {
      alert("Errore durante l'eliminazione della relazione.");
    }
  };

  const handleSave = async () => {
    if (
      !teacherData.idprovincia ||
      !teacherData.idcomune ||
      !teacherData.idscuola
    ) {
      alert("Provincia, Comune e Scuola sono campi obbligatori.");
      return;
    }
    if (!teacherData.nominativo) {
      alert("Il campo Nominativo è obbligatorio.");
      return;
    }
    if (!teacherData.cf) {
      alert("Il campo Codice Fiscale è obbligatorio.");
      return;
    }
    if (!teacherData.annoscolastico) {
      alert("Il campo Anno Scolastico è obbligatorio.");
      return;
    }
    if (!teacherData.email) {
      alert("Il campo Email è obbligatorio.");
      return;
    }
    // if (subjects.length === 0) {
    //   alert("Devi selezionare almeno una materia principale.");
    //   return;
    // }

    if (
      teacherData.cf !== oldTeacherData.cf ||
      teacherData.email !== oldTeacherData.email
    ) {
      const checkResponse = await fetch(
        `${axios.defaults.baseBFFUrl}/fe/checkUserEmailAndCF?email=${teacherData.email}&cf=${teacherData.cf}&schoolId=${teacherData.idscuola}`,
        getFetchOptions("application/json", {}, "GET")
      );

      const checkResult = await checkResponse.json();

      if (
        teacherData.email !== oldTeacherData.email &&
        checkResult.emailExists
      ) {
        setEmailError("Email già utilizzata da un altro insegnante");
        return;
      }
      if (teacherData.cf !== oldTeacherData.cf && checkResult.cfExists) {
        setCfError("Codice Fiscale già utilizzato da un altro insegnante");
        return;
      }
    }

    const fetchOptions = getFetchOptions(
      "application/x-www-form-urlencoded",
      { teacherData, teacherId: teacherData.id },
      "PUT"
    );
    await fetch(`${axios.defaults.baseBFFUrl}/fe/updateTeacher`, fetchOptions)
      .then(() => {
        window.location.href = "/teachers";
      })
      .catch((error) => {
        console.error("Error updating teacher:", error);
        alert("Errore durante l'aggiornamento dell'insegnante. Riprova.");
      });
  };

  const handleSaveRelation = async () => {
    const duplicates = [];
    relationTeachersData.forEach((relation, idx) => {
      if (
        relation.classId &&
        relation.subjectId &&
        relationTeachersData.some(
          (r, i) => i !== idx && r.classId === relation.classId
        )
      ) {
        duplicates.push(`${relation.classId}-${relation.subjectId}`);
      }
    });
    if (duplicates.length > 0) {
      alert("Esiste gia` questa classe associata all'insegnante");
      return;
    }

    let newRelations = relationTeachersData.filter(
      (relation) => relation.new === true
    );

    if (!newRelations || newRelations.length === 0) {
      alert("Nessuna relazione da salvare.");
      return;
    }

    const fetchOptions = getFetchOptions(
      "application/json",
      {
        userId: teacherData.id,
        classData: newRelations,
        schoolYear: schoolYear,
        schoolId: teacherData.idscuola,
      },
      "POST"
    );

    await fetch(
      `${axios.defaults.baseBFFUrl}/fe/addTeacherClasses`,
      fetchOptions
    )
      .then((response) => {
        let result = response.json();
        if (result.error) {
          throw new Error(result.error);
        }
        alert("Associazione classi salvate con successo!");
        window.location.reload();
      })
      .catch((error) => {
        console.error("Error saving relations:", error);
        alert("Errore durante il salvataggio delle relazioni. Riprova.");
      });
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/teachers">
        <button className="btn btn-primary mb-4" type="button">
          <i className="bi bi-arrow-left"></i> Torna alla lista insegnanti
        </button>
      </a>

      {/* Profile Image Upload */}
      <div className="card custom-card">
        <div className="card-header">Immagine del profilo</div>
        <div className="card-body">
          <div className="row row-cols-1 row-cols-lg-2 align-items-center">
            <div className="col-auto">
              {teacherData.tokenimg && (
                <span
                  className="avatar mx-3 mb-3 mb-lg-0"
                  style={{ backgroundImage: `url(${teacherData.tokenimg})` }}
                ></span>
              )}
            </div>
            <div className="col">
              <div className="input-group">
                <input
                  type="file"
                  className="form-control"
                  id="avatar"
                  aria-describedby="btnAvatar"
                  onChange={(e) => setAvatar(e.target.files[0])}
                  accept="image/*"
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  id="btnAvatar"
                  onClick={handleAvatarChange}
                >
                  Carica
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* General Data */}
      <div className="card custom-card">
        <div className="card-header card-title">
          <span>Modifica</span>
        </div>
        <div className="card-body">
          <form
            id="teacherForm"
            autoComplete="off"
            onSubmit={(e) => e.preventDefault()}
          >
            <div className="row mb-5">
              <div className="col-12 col-lg-4">
                <label htmlFor="province">
                  Provincia <b>*</b>
                </label>
                <Select
                  options={provsOption}
                  id="province"
                  name="province"
                  value={
                    provsOption.find(
                      (option) => option.value === teacherData.idprovincia
                    ) || null
                  }
                  onChange={handleProvinceChange}
                  classNamePrefix="react-select"
                  placeholder="Scegli provincia..."
                  isSearchable
                  isClearable
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="city">
                  Comune <b>*</b>
                </label>
                <Select
                  options={cityOption}
                  id="city"
                  name="city"
                  value={
                    cityOption.find(
                      (option) => option.value === teacherData.idcomune
                    ) || null
                  }
                  onChange={handleCityChange}
                  classNamePrefix="react-select"
                  placeholder="Scegli comune..."
                  isSearchable
                  isClearable
                />
              </div>
              <div className="col-12 col-lg-4">
                <label htmlFor="school">
                  Scuola Principale <b>*</b>
                </label>
                <Select
                  options={schoolOption}
                  id="school"
                  name="school"
                  value={
                    schoolOption.find(
                      (option) => option.value === teacherData.idscuola
                    ) || null
                  }
                  onChange={handleSchoolChange}
                  classNamePrefix="react-select"
                  placeholder="Scegli scuola..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-12 col-lg-4">
                <label htmlFor="nominativo">
                  Nominativo <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="nominativo"
                  name="nominativo"
                  value={teacherData.nominativo || ""}
                  onChange={(e) =>
                    setTeacherData({
                      ...teacherData,
                      nominativo: e.target.value,
                    })
                  }
                  required
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="telefono">Telefono</label>
                <input
                  className="form-control"
                  id="telefono"
                  name="telefono"
                  type="tel"
                  value={teacherData.telefono || ""}
                  onChange={(e) =>
                    setTeacherData({ ...teacherData, telefono: e.target.value })
                  }
                />
              </div>

              <div className="col-12 col-lg-4">
                <label htmlFor="cf">
                  Codice Fiscale <b>*</b>
                </label>
                <input
                  className={`form-control ${cfError ? "is-invalid" : ""}`}
                  id="cf"
                  name="cf"
                  value={teacherData.cf || ""}
                  onChange={(e) => {
                    setTeacherData({
                      ...teacherData,
                      cf: e.target.value,
                    });
                    if (cfError) setCfError("");
                  }}
                />
                {cfError && <div className="invalid-feedback">{cfError}</div>}
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-12 col-lg-4">
                <label htmlFor="annoscolastico">
                  Anno scolastico <b>*</b>
                </label>
                <select
                  className="form-control"
                  id="annoscolastico"
                  name="annoscolastico"
                  value={teacherData.annoscolastico || ""}
                  onChange={(e) =>
                    setTeacherData({
                      ...teacherData,
                      annoscolastico: e.target.value,
                    })
                  }
                  disabled
                >
                  <option value="">Scegli anno scolastico...</option>
                  {Array.from({ length: 10 }).map((_, idx) => {
                    const year = new Date().getFullYear() - 5 + idx;
                    return (
                      <option key={year} value={`${year}${year + 1}`}>
                        {`${year}/${year + 1}`}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="col-12 col-lg-4">
                <label htmlFor="email">
                  Email <b>*</b>
                </label>
                <input
                  className={`form-control ${emailError ? "is-invalid" : ""}`}
                  id="email"
                  name="email"
                  value={teacherData.email || ""}
                  onChange={(e) => {
                    setTeacherData({ ...teacherData, email: e.target.value });
                    if (emailError) setEmailError("");
                  }}
                />
                {emailError && (
                  <div className="invalid-feedback">{emailError}</div>
                )}
              </div>
              {/* Materie Principali disabilitato */}
              {/* <div className="col-12 col-lg-4">
                <label htmlFor="subject">
                  Materie Principali <b>*</b>
                </label>
                <Select
                  options={subjectOption}
                  id="subject"
                  name="subject"
                  value={subjectOption.filter((option) => {
                    return subjects.includes(option.label);
                  })}
                  onChange={(selectedOptions) =>
                    setSubjects(
                      selectedOptions
                        ? selectedOptions.map((opt) => opt.value)
                        : []
                    )
                  }
                  placeholder="Scegli materie..."
                  isMulti
                  isSearchable
                  isDisabled
                />
              </div> */}
            </div>

            <div className="saveButtonContainer">
              <button
                type="button"
                className="btn btn-success text-uppercase"
                onClick={handleSaveWithCFCheck}
              >
                <i className="fa fa-save"></i> Salva
              </button>
            </div>
          </form>
        </div>
      </div>
      <div className="card custom-card">
        <div className="card-header card-title">
          <div className="d-flex justify-content-between align-items-center w-100">
            <div>Assegnazione classi e materie</div>
            <div>
              <div className="d-flex justify-content-end">
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={() =>
                    setRelationTeachersData([
                      ...relationTeachersData,
                      {
                        id: Date.now(),
                        classId: null,
                        subjectId: null,
                        new: true,
                      },
                    ])
                  }
                >
                  <i className="bi bi-plus"></i> Aggiungi classe e materia
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="card-body">
          {relationTeacherClasses.length > 0 ? (
            relationTeachersData?.map((relation, idx) => (
              <div className="row mb-3" key={relation.id || idx}>
                <div className="col-12 col-lg-5">
                  <label htmlFor={`class-${relation.id || idx}`}>Classe</label>
                  <Select
                    options={relationTeacherClasses}
                    id={`class-${relation.id || idx}`}
                    value={
                      relationTeacherClasses.find(
                        (opt) => opt.value === relation.classId
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleRelationChange(
                        idx,
                        "classId",
                        selectedOption ? selectedOption.value : null
                      )
                    }
                    classNamePrefix="react-select"
                    placeholder="Scegli classe..."
                    isClearable
                    isDisabled={relation.new ? false : true}
                  />
                </div>
                <div className="col-12 col-lg-5">
                  <label htmlFor={`subject-${relation.id || idx}`}>
                    Materia
                  </label>
                  <Select
                    options={subjectOption}
                    id={`subject-${relation.id || idx}`}
                    value={
                      subjectOption.find(
                        (opt) => opt.value === relation.subjectId
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleRelationChange(
                        idx,
                        "subjectId",
                        selectedOption ? selectedOption.value : null
                      )
                    }
                    classNamePrefix="react-select"
                    placeholder="Scegli materia..."
                    isClearable
                    isDisabled={relation.new ? false : true}
                  />
                </div>
                <div className="col-12 col-lg-2 d-flex align-items-end">
                  <div className="d-flex w-100 justify-content-end">
                    <button
                      className="btn btn-danger"
                      type="button"
                      onClick={() => handleDeleteRelation(relation.id)}
                    >
                      <i className="bi bi-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div>Caricamento classi...</div>
          )}
        </div>
        <div className="row m-2">
          <div className="d-flex justify-content-end">
            <button
              className="btn btn-success"
              type="button"
              onClick={handleSaveRelation}
            >
              <i className="bi bi-floppy"></i> Salva
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTeacher;
